module.exports = __webpack_public_path__ + "static/img/p_home_orientation.1c696309.png";